
export const appConfig = {
  colors: ['#E54B3C', '#F66021', '#F89307', '#F6B41A', '#BEC932', '#7AB040', '#429F46', '#009687', '#00ADC3', '#2790BC'],
}
